/**
 * Payment Method Status Hook
 *
 * Checks whether the workspace has a valid payment method on file.
 * Used by the billing settings section to show contextual messaging
 * (e.g. "Add payment method" vs "Manage billing" during trial).
 */

import { useCheckPaymentStatusQuery } from '@/lib/graphql/types-and-hooks';
import { useWorkspaceId } from './use-workspace-id';

export const usePaymentMethodStatus = (options?: { skip?: boolean }) => {
  const workspaceId = useWorkspaceId();

  const { data, loading, error, refetch } = useCheckPaymentStatusQuery({
    variables: {
      workspaceId: workspaceId ? parseInt(workspaceId) : 0,
    },
    skip: !workspaceId || (options?.skip ?? false),
    fetchPolicy: 'network-only',
  });

  return {
    hasValidCard: data?.paymentMethodStatus?.hasValidCard ?? false,
    loading,
    error,
    refetch,
  };
};
